import { useSelector } from 'react-redux';
import { type Brands as BrandsType } from 'types/Brands';

const useCurrency = (): string =>
  useSelector(
    ({ Brands }: { Brands: BrandsType }) => Brands.brand.multinational.currency
  );

export default useCurrency;
